import { render, staticRenderFns } from "./ContractorContactPerson.vue?vue&type=template&id=04bf7737&"
import script from "./ContractorContactPerson.vue?vue&type=script&lang=js&"
export * from "./ContractorContactPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports